import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { applyPageMeta } from '@/lib/seo';
import { buildPageTitle, useStoreName } from '@/hooks/useStoreName';

/**
 * 404
 *
 * Marka tonu var ama espri dozu düşük: kullanıcı kaybolmuş hissetmesin,
 * bir sonraki adımı hemen görsün.
 */
export function NotFoundPage() {
  const storeName = useStoreName();
  useEffect(() => {
    applyPageMeta({
      title: buildPageTitle("Sayfa bulunamadı", storeName),
      canonicalPath: '/404',
      noindex: true,
    });
  }, [storeName]);

  return (
    <div className="container-page flex min-h-[64svh] flex-col items-center justify-center py-20 text-center">
      {/* Sayısal 404 sessiz kalır; asıl mesaj cümledir. */}
      <p className="font-mono text-sm tracking-widest text-ink-subtle">404</p>

      <h1 className="mt-5 max-w-lg font-serif text-2xl leading-tight text-ink sm:text-3xl">
        Aradığınız çiçek burada değil.
      </h1>

      <p className="mt-4 max-w-prose text-base text-ink-muted">
        Bağlantı değişmiş ya da sayfa kaldırılmış olabilir. Aşağıdan devam
        edebilirsiniz.
      </p>

      <div className="mt-8 flex flex-wrap justify-center gap-3">
        <Button asChild>
          <Link to="/koleksiyon/cok-satanlar">Çiçekleri keşfet</Link>
        </Button>

        <Button asChild variant="secondary">
          <Link to="/">Ana sayfa</Link>
        </Button>
      </div>
    </div>
  );
}
